export default __webpack_public_path__ + "static/media/podcast_tone.9c109d92.gif";